import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';
import { ButtonSize, ButtonVariant, defaultButtonClasses, getButtonIconSize } from '.';
import { CustomSVG } from '../../../src';
import { Spinner } from '../Spinner';

interface AnchorButtonProps extends HTMLAttributes<HTMLAnchorElement> {
	href: string;
	target?: string;
	icon?: CustomSVG;
	iconClass?: string;
	circle?: boolean;
	spinner?: boolean;
	variant?: ButtonVariant;
	size?: ButtonSize;
	iconSize?: ButtonSize;
	disabled?: boolean;
	download?: string;
}

export function AnchorButton({
	children,
	variant,
	size = ButtonSize.M,
	spinner,
	icon: Icon,
	iconClass,
	iconSize,
	className,
	circle,
	disabled = false,
	...props
}: AnchorButtonProps) {
	return (
		<a className={clsx(defaultButtonClasses, variant, circle ? 'p-2' : size, className, disabled && 'pointer-events-none')} {...props}>
			{spinner ? <Spinner className={getButtonIconSize(iconSize || size)} /> : children}
			{Icon && (
				<Icon className={clsx(!circle && 'ml-2 -mr-1', getButtonIconSize(iconSize || size), iconClass)} aria-hidden="true" />
			)}{' '}
		</a>
	);
}

export const PrimaryAnchorButton: React.FC<AnchorButtonProps> = props => <AnchorButton {...props} variant={ButtonVariant.primary} />;
export const OutlineAnchorButton: React.FC<AnchorButtonProps> = props => <AnchorButton {...props} variant={ButtonVariant.outline} />;
export const ColouredAnchorButton: React.FC<AnchorButtonProps> = props => <AnchorButton {...props} variant={ButtonVariant.coloured} />;
